import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import * as PAGE from '@Pages';
import Wrapper from './../wrapper';

// const protectedRoutes = [{
//     pathname: '/',
//     element: <PAGE.Home />
//   },
//   {
//     pathname: '/clothes',
//     element: <PAGE.Clothes />
//   },
//   {
//     pathname: '/clothes/:slug',
//     element: <PAGE.Detail />
//   },
//   {
//     pathname: '/categories',
//     element: <PAGE.Categories />
//   },
//   {
//     pathname: '/categories/:category',
//     element: <PAGE.Clothes />
//   },
//   {
//     pathname: '/about',
//     element: <PAGE.About />
//   },
//   {
//     pathname: '/profile',
//     element: <PAGE.Profile />
//   },
// ];

// const unprotectedRoutes = [
//   {
//     pathname: '/login',
//     element: <PAGE.Login />,
//   },
//   {
//     pathname: '/registration',
//     element: <PAGE.Registration />,
//   }
// ];

export default function Layout() {
  // const location = useLocation();
  // const navigation = useNavigate();
  const isLoggedIn = useSelector(state => state).accessToken !== undefined;

  // useEffect(() => {
  //   const isAuthRoutes = unprotectedRoutes.find(route => route.pathname === location.pathname);

  //   if (isLoggedIn && isAuthRoutes) {
  //     navigation('/');
  //   }

  //   if (!isLoggedIn && !isAuthRoutes) {
  //     navigation('/login');
  //   }
  // }, [isLoggedIn]);

  return isLoggedIn ? (
    <Routes>
      <Route path="/" element={<Wrapper />}>
        <Route index element={<PAGE.Home />} />
        <Route path="clothes" element={<PAGE.Clothes />} />
        <Route path="clothes/:slug" element={<PAGE.Detail />} />
        <Route path="categories" element={<PAGE.Categories />} />
        <Route path="categories/:category" element={<PAGE.Clothes />} />
        <Route path="about" element={<PAGE.About />} />
        <Route path="profile" element={<PAGE.Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<Wrapper />}>
        <Route index element={<PAGE.Home />} />
        <Route path="about" element={<PAGE.About />} />
      </Route>
      <Route exact path="/login" element={<PAGE.Login />} />
      <Route exact path="/registration" element={<PAGE.Registration />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}